jQuery(document).ready(function ($) {
  var spflag = true;
  var animeSpd = 400;
  var menuHideHeight = 1000;
  var menuShowHeight = 1200;
  var scrollpos;

  // メニュー開閉
  $('.js-product-navi-openbutton').on('click', function () {
    $(this).hide();
    $('.js-product-navi-closebutton').show();
    $('.js-product-navi-list').slideDown(animeSpd);
    $('.js-product-navi').addClass('is-open');
  });

  $('.js-product-navi-closebutton').on('click', function () {
    $(this).hide();
    $('.js-product-navi-openbutton').show();
    $('.js-product-navi-list').hide();
    $('.js-product-navi').removeClass('is-open');
  });

  // スクロール時のアクション
  $(window).on('scroll', function () {
    // メニュー表示・非表示
    if ($(this).scrollTop() > menuShowHeight) {
      $('.js-product-navi').addClass('is-shown');
    } else if ($(this).scrollTop() > menuHideHeight) {
      $('.js-product-navi').addClass('is-hide');
    } else {
      $('.js-product-navi').removeClass('is-shown');
      $('.js-product-navi').removeClass('is-hide');
    }
  });

  // ギャラリーの設定
  if ($('.js-product-gallery')[0]) {
    var $gallery = $('.js-product-gallery');
    $gallery.masonry({
      gutter: 20,
      columnWidth: 235
    });
    scrollpos = 0;
    scrollpos = $(window).scrollTop() + $(window).height();
    if (scrollpos > $gallery.offset().top) {
      $gallery.masonry('layout');
    }
    $(window).scroll(function () {
      scrollpos = $(window).scrollTop() + $(window).height();
      if (scrollpos > $gallery.offset().top) {
        $gallery.masonry('layout');
      }

      $('.js-fadein').each(function () { // スクロールでフェードイン
        var objPos = $(this).offset().top;
        if (scrollpos > objPos) {
          $(this).css({
            opacity: 1,
            transform: 'translate(0, 0)',
            transition: 'all 1000ms'
          });
        }
      });
    });
  }

  // Other Lineup カルーセル
  if ($('.js-product-lineupslick')[0]) {
    var slideCount = $('.js-product-lineupslick .site-pageheader-spnavi-models-model').length;
    $('.js-product-lineupslick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: slideCount,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });

    if (slideCount >= 4) {
      $('.js-product-lineupslick').addClass("allmodel");
    }
  }

  // ムービーカルーセル
  if ($('.js-product-movieslick')[0]) {
    $('.js-product-movieslick').on('init', function () {
      if ($('.js-modaal-video')[0]) {
        $('.js-modaal-video').modaal({
          type: 'video',
          overlay_opacity: 0.9,
          after_open: function () {
            $('.modaal-video-container').addClass('is-open');
          }
        });
      }
    });
    $('.js-product-movieslick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 9999,
        settings: 'unslick'
      },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }

  // ギャラリーカルーセル
  if ($('.js-product-galleryslick')[0]) {
    gallerySlickSet();
  }

  // バリエーションカルーセル周り
  if ($('.js-variation-cover')[0]) {
    $('.js-variation-cover').each(function () { // バリエーションごとのループ js-variation-cover 毎

      // 初期値 ・ 変数設定
      var $variation = $(this);
      var $slick = $('.js-variation-slick', this);
      var $bodySlick = $('.js-variation-content-body', this);
      var $interiorSlick = $('.js-variation-content-interior', this);
      var $wheelSlick = $('.js-variation-content-wheel', this);
      var $caliperSlick = $('.js-variation-content-caliper', this);
      var $bodyColor = $('.js-bodyColorList', this);
      var $interiorColor = $('.js-interiorColorList', this);
      var $wheelColor = $('.js-wheelColorList', this);
      var $caliperColor = $('.js-caliperColorList', this);
      var $bodyColorball = $('.js-bodyColorList li', this);
      var $interiorColorball = $('.js-interiorColorList li', this);
      var $wheelColorball = $('.js-wheelColorList li', this);
      var $caliperColorball = $('.js-caliperColorList li', this);
      var bodyColorNum = $(this).data('bodycolor'); // ボディーカラーの設定値
      var interiorColorNum = $(this).data('interiorcolor'); // インテリアカラーの設定値
      var wheelColorNum = $(this).data('wheelcolor'); // ホイルカラーの設定値
      var caliperColorNum = $(this).data('calipercolor'); // キャリパーカラーの設定値
      var $bodycolorName = $('.js-bodycolor-name', this);
      var $interiorcolorName = $('.js-interiorcolor-name', this);
      var $wheelcolorName = $('.js-wheelcolor-name', this);
      var $calipercolorName = $('.js-calipercolor-name', this);

      $bodyColorball.each(function (index) { // ボディーカラーボール
        var bgcolor = $(this).data('color');
        var bordercolor = $(this).data('border');

        $(this).css({
          background: 'rgb(' + bgcolor + ')'

        });
        if ($(this).data('border')) {
          $(this).css({
            border: '1px solid rgb(' + bordercolor + ')'
          });
        } else {
          $(this).css({
            border: '1px solid rgb(' + bgcolor + ')'
          });
        }

        if (index === bodyColorNum) {
          $(this).addClass('is-active');
          $bodycolorName.html($(this).html());

          if ($(this).data('border')) {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }

        var that = $(this);
        $(this).on('mouseover', function () {
          if (that.data('border')) {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }).on('mouseleave', function () {
          if (!$(that).hasClass('is-active')) {
            that.css({
              boxShadow: 'none'
            });
          }
        }).on('click', function () {
          if (!$(this).hasClass('is-active')) {
            $bodyColorball.removeClass('is-active').css({
              boxShadow: 'none'
            });
            bodyColorNum = $bodyColorball.index(this);
            $variation.data('bodycolor', bodyColorNum);

            $bodycolorName.html($(this).html());

            $(this).addClass('is-active');
            if ($(this).data('border')) {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
              });
            } else {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
              });
            }
            changeImage($variation);
          }
        });
      });

      $interiorColorball.each(function (index) {
        var bgcolor = $(this).data('color');
        var bordercolor = $(this).data('border');

        $(this).css({
          background: 'rgb(' + bgcolor + ')'

        });
        if ($(this).data('border')) {
          $(this).css({
            border: '1px solid rgb(' + bordercolor + ')'
          });
        } else {
          $(this).css({
            border: '1px solid rgb(' + bgcolor + ')'
          });
        }

        if (index === interiorColorNum) {
          $(this).addClass('is-active');
          $interiorcolorName.html($(this).html());

          if ($(this).data('border')) {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }

        var that = $(this);
        $(this).on('mouseover', function () {
          if (that.data('border')) {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }).on('mouseleave', function () {
          if (!$(that).hasClass('is-active')) {
            that.css({
              boxShadow: 'none'
            });
          }
        }).on('click', function () {
          if (!$(this).hasClass('is-active')) {
            $interiorColorball.removeClass('is-active').css({
              boxShadow: 'none'
            });
            interiorColorNum = $interiorColorball.index(this);
            $variation.data('interiorcolor', interiorColorNum);

            $interiorcolorName.html($(this).html());

            $(this).addClass('is-active');
            if ($(this).data('border')) {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
              });
            } else {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
              });
            }
            changeImage($variation);
          }
        });
      });

      $wheelColorball.each(function (index) {
        var bgcolor = $(this).data('color');
        var bordercolor = $(this).data('border');

        $(this).css({
          background: 'rgb(' + bgcolor + ')'

        });
        if ($(this).data('border')) {
          $(this).css({
            border: '1px solid rgb(' + bordercolor + ')'
          });
        } else {
          $(this).css({
            border: '1px solid rgb(' + bgcolor + ')'
          });
        }

        if (index === wheelColorNum) {
          $(this).addClass('is-active');
          $wheelcolorName.html($(this).html());

          if ($(this).data('border')) {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }

        var that = $(this);
        $(this).on('mouseover', function () {
          if (that.data('border')) {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }).on('mouseleave', function () {
          if (!$(that).hasClass('is-active')) {
            that.css({
              boxShadow: 'none'
            });
          }
        }).on('click', function () {
          if (!$(this).hasClass('is-active')) {
            $wheelColorball.removeClass('is-active').css({
              boxShadow: 'none'
            });
            wheelColorNum = $wheelColorball.index(this);
            $variation.data('wheelcolor', wheelColorNum);

            $wheelcolorName.html($(this).html());

            $(this).addClass('is-active');
            if ($(this).data('border')) {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
              });
            } else {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
              });
            }
            changeImage($variation);
          }
        });
      });

      $caliperColorball.each(function (index) {
        var bgcolor = $(this).data('color');
        var bordercolor = $(this).data('border');

        $(this).css({ background: 'rgb(' + bgcolor + ')' });

        if ($(this).data('border')) {
          $(this).css({border: '1px solid rgb(' + bordercolor + ')'});
        } else {
          $(this).css({border: '1px solid rgb(' + bgcolor + ')'});
        }

        if (index === caliperColorNum) {
          $(this).addClass('is-active');
          $calipercolorName.html($(this).html());

          if ($(this).data('border')) {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            $(this).css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }

        var that = $(this);
        $(this).on('mouseover', function () {
          if (that.data('border')) {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
            });
          } else {
            that.css({
              boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
            });
          }
        }).on('mouseleave', function () {
          if (!$(that).hasClass('is-active')) {
            that.css({
              boxShadow: 'none'
            });
          }
        }).on('click', function () {
          if (!$(this).hasClass('is-active')) {
            $caliperColorball.removeClass('is-active').css({
              boxShadow: 'none'
            });
            caliperColorNum = $caliperColorball.index(this);
            $variation.data('calipercolor', caliperColorNum);

            $calipercolorName.html($(this).html());

            $(this).addClass('is-active');
            if ($(this).data('border')) {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bordercolor + ',.5)'
              });
            } else {
              $(this).css({
                boxShadow: '0 0 0 2px rgba(' + bgcolor + ',.5)'
              });
            }
            changeImage($variation);
          }
        });
      });

      // slickの設定

      $slick.on('init reInit', function (event, slick, currentSlide) {
        $('.u-product-prev-arrow span', $slick).html($('.slick-current .u-product-variation-slick-content', $slick).data('slickprev'));
        $('.u-product-next-arrow span', $slick).html($('.slick-current .u-product-variation-slick-content', $slick).data('slicknext'));
      });

      $slick.slick({
        dots: false,
        speed: animeSpd,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,

        prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg><span></span></div>',
        nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg><span></span></div>'
      });

      $slick.on('afterChange', function (event, slick, currentSlide) {
        $('.u-product-prev-arrow span', $slick).html($('.slick-current .u-product-variation-slick-content', $slick).data('slickprev'));
        $('.u-product-next-arrow span', $slick).html($('.slick-current .u-product-variation-slick-content', $slick).data('slicknext'));

        var cat = $('.slick-current .u-product-variation-slick-content', $slick).data('category');

        if (cat === 'body') {
          $('.js-bodyColorCover', $variation).show();
          $('.js-interiorColorCover', $variation).hide();
          $('.js-wheelColorCover', $variation).hide();
          $('.js-caliperColorCover', $variation).hide();
        } else if (cat === 'interior') {
          $('.js-bodyColorCover', $variation).hide();
          $('.js-interiorColorCover', $variation).show();
          $('.js-wheelColorCover', $variation).hide();
          $('.js-caliperColorCover', $variation).hide();
        } else if (cat === 'wheel') {
          $('.js-wheelColorCover', $variation).show();
          $('.js-bodyColorCover', $variation).hide();
          $('.js-interiorColorCover', $variation).hide();
          $('.js-caliperColorCover', $variation).hide();
        } else if (cat === 'caliper') {
          $('.js-wheelColorCover', $variation).hide();
          $('.js-bodyColorCover', $variation).hide();
          $('.js-interiorColorCover', $variation).hide();
          $('.js-caliperColorCover', $variation).show();
        } else {
          $('.js-bodyColorCover', $variation).hide();
          $('.js-interiorColorCover', $variation).hide();
          $('.js-wheelColorCover', $variation).hide();
          $('.js-caliperColorCover', $variation).hide();
        }
      });

      changeImage($variation);
    }); // バリエーションごとのループ js-variation-cover 毎

    $('.js-interiorColorCover, .js-wheelColorCover, .js-caliperColorCover').hide();
  }

  function changeImage ($target) {
    var $bodySlick = $target.find('.js-variation-content-body');
    var $interiorSlick = $target.find('.js-variation-content-interior');
    var $wheelSlick = $target.find('.js-variation-content-wheel');
    var $caliperSlick = $target.find('.js-variation-content-caliper');
    var bodyColorNum = $target.data('bodycolor'); // ボディーカラーの設定値
    var interiorColorNum = $target.data('interiorcolor'); // インテリアカラーの設定値
    var wheelColorNum = $target.data('wheelcolor'); // wheelカラーの設定値
    var caliperColorNum = $target.data('calipercolor'); // caliperカラーの設定値

    $bodySlick.each(function () {
      $('.js-imagelist li', this).hide();
      $('.js-imagelist li', this).eq(bodyColorNum).show();
    });
    $interiorSlick.each(function () {
      $('.js-imagelist li', this).hide();
      $('.js-imagelist li', this).eq(interiorColorNum).show();
    });
    $wheelSlick.each(function () {
      $('.js-imagelist li', this).hide();
      $('.js-imagelist li', this).eq(wheelColorNum).show();
    });
    $caliperSlick.each(function () {
      $('.js-imagelist li', this).hide();
      $('.js-imagelist li', this).eq(caliperColorNum).show();
    });
  }

  // バリエーションカラー表示（モデル名周り）
  if ($(".js-colorChip")[0]) {
    $(".js-colorChip").each(function () {
      var color = $(this).data("color"),
        border = $(this).data("border");
      $(this).css({
        background: 'rgb(' + color + ')'
      });
      if ($(this).data('border')) {
        $(this).css({
          border: '1px solid rgb(' + border + ')'
        });
      } else {
        $(this).css({
          border: '1px solid rgb(' + color + ')'
        });
      }
    });
  }

  // slick primary
  if ($('.js-slick-primary')[0]) {
    $('.js-slick-primary-thumbnail').each(function () {
      var $that = $(this);
      $('li', this).each(function () {
        var index = $('li', $that).index(this);
        $(this).attr('data-index', index);
      });
    });

    $('.js-slick-primary').on('init', function (slick) {
      var index = $('.slide-item.slick-slide.slick-current').attr('data-slick-index');
      $('.js-slick-primary-thumbnail li' + '[data-index="' + index + '"]').addClass('thumbnail-current');
    });

    $('.js-slick-primary').slick({
      dots: false,
      speed: animeSpd,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%',
            infinite: true
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });

    $('.js-slick-primary-thumbnail li').on('click', function () {
      var index = $(this).attr('data-index');
      var parent = $(this).parents('.js-slick-primary-thumbnail');
      var tareget = parent.data('target');
      $('#' + tareget).slick('slickGoTo', index, false);
    });

    $('.js-slick-primary').on('afterChange', function (event, slick, currentSlide) {
      var parent = $(slick.$slider);
      $('.js-slick-primary-thumbnail li').each(function () {
        $(this).removeClass('thumbnail-current');
      });
      $('.js-slick-primary-thumbnail').each(function () {
        var target = $(this).data('target');
        var currentslide = $('#' + target).slick('slickCurrentSlide');
        $('li' + '[data-index="' + currentslide + '"]', this).addClass('thumbnail-current');
      });
    });

    $('.js-slick-prevarrow').on('click', function () {
      var parent = $(this).parents('.js-slick-primary-thumbnail');
      var tareget = parent.data('target');
      $('#' + tareget).slick('slickPrev');
    });
    $('.js-slick-nextarrow').on('click', function () {
      var parent = $(this).parents('.js-slick-primary-thumbnail');
      var tareget = parent.data('target');
      $('#' + tareget).slick('slickNext');
    });
  }

  if ($('.js-slick-secondary')[0]) {
    secondarySlickSet();
  }

  if ($('.js-slick-tertiary')[0]) {
    tertiarySlickSet();
    if ($('.js-modaal-video')[0]) {
      $('.js-modaal-video').modaal({
        type: 'video',
        overlay_opacity: 0.9,
        after_open: function () {
          $('.modaal-video-container').addClass('is-open');
        }
      });
    }
  }

  // Spec price カルーセル
  if ($('.js-pricelist-slick')[0]) {
    $('.js-pricelist-slick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 9999,
        settings: 'unslick'
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }

  // タブ初期設定
  if ($('.js-tabnavi')[0]) {
    $('.js-tabnavi').each(function () {
      var configVariation = getParam('variation');
      var hashTab = $('a[href^="#' + configVariation + '"]', this);
      // 初期表示リセット
      if (configVariation != '' && hashTab.length == 1) {
        $('a', this).removeClass('is-active');
        hashTab.addClass('is-active');
      }
      // タブの何番目がis-activeかを取得して保存
      var tabNum;
      tabNum = $('li a', this).index($('a.is-active', this));
      // タブの表示対象を取得
      var tabchildren = $('+ .js-tabcontents > *', this);
      // タブの表示対象を一旦全て非表示
      tabchildren.hide();

      // n番目を表示
      tabchildren.eq(tabNum).show();
    });

    // タブクリック時
    $('.js-tabnavi a').on('click', function () {
      var tabNum;
      var parentTab;
      if (!$(this).hasClass('is-active')) {
        parentTab = $(this).parents('.js-tabnavi');
        tabNum = $('a', parentTab).index($(this));
        $('a', parentTab).removeClass('is-active');
        $(this).addClass('is-active');

        // タブの表示対象を取得
        var tabchildren = $('+ .js-tabcontents > *', parentTab);

        // タブの表示対象を一旦全て非表示
        tabchildren.hide();

        // n番目を表示
        var showContent = tabchildren.eq(tabNum);
        showContent.show();

        $('.js-variation-slick', showContent).slick('setPosition');

        // GIULIAのみ
        var thisID = $(this).attr('href');
        if (thisID === '#fueleconomy') {
          $('.performance-engine-dieselsecond').addClass('is-fueletab');
        } else if (thisID === '#technology') {
          $('.performance-engine-dieselsecond').removeClass('is-fueletab');
        }
      }

      return false;
    });
  }



  var mediaQuery = matchMedia('(min-width: 768px)');
  // ページが読み込まれた時に実行
  // ウィンドウサイズが変更されても実行されるように
  mediaQuery.addListener(handle);

  function handle (mq) {
    if (mq.matches) {
    }else {
      if ($('.js-product-movieslick')[0]) {
        movieSlicSet();
      }
      if ($('.js-product-galleryslick')[0]) {
        gallerySlickSet();
      }
      if ($('.js-slick-secondary')[0]) {
        secondarySlickSet();
      }
      if ($('.js-slick-tertiary')[0]) {
        tertiarySlickSet();
      }
    }
  }

  function movieSlicSet () {
    $('.js-product-movieslick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 2000,
        settings: 'unslick'
      },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }
  function gallerySlickSet () {
    $('.js-product-galleryslick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 2000,
        settings: 'unslick'
      },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }
  function secondarySlickSet () {
    $('.js-slick-secondary').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 9999,
        settings: 'unslick'
      },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }

  function tertiarySlickSet () {
    $('.js-slick-tertiary').on('init', function () {
      $('.slick-dots li:first-child svg').addClass('is-active');
      $('.slick-current').addClass('is-active');
    }).on('beforeChange', function () {
      $('.slick-active svg').removeClass('is-active');
      $('.slick-current').removeClass('is-active');
    }).on('afterChange', function () {
      $('.slick-active svg').addClass('is-active');
      $('.slick-current').addClass('is-active');
    });

    $('.js-slick-tertiary').not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [{
        breakpoint: 9999,
        settings: 'unslick'
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }],
      customPaging: function (slider, i) {
        return $('<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g><circle cx="7" cy="7" r="7" stroke="none"/><circle cx="7" cy="7" r="6"/></g></svg>');
      },
      prevArrow: '<div class="u-slide-arrow u-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 29"><defs><clipPath id="a"><path data-name="長方形 2478" transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="マスクグループ 161" transform="rotate(180 7.929 14.429)" clip-path="url(#a)" opacity=".5"><path data-name="前面オブジェクトで型抜き 4" d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>',
      nextArrow: '<div class="u-slide-arrow u-next-arrow"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 29"><defs><clipPath id="a"><path data-name="長方形 2478" transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="マスクグループ 161" transform="rotate(180 7.929 14.429)" clip-path="url(#a)" opacity=".5"><path data-name="前面オブジェクトで型抜き 4" d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>'
    }).on('touchmove', function (event, slick, currentSlide, nextSlide) {
      $('.js-slick-tertiary').slick('slickPlay');
    });
  }

  function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
});
